import React, { useEffect, useState } from 'react'
import { TableCPOLD2 } from 'common/old-refactory/table/TableCPOLD2'
import { CardDashboardWidgetWrapperCP } from 'main/modules/dashboard/components/card-dashboard-widget-wrapper/CardDashboardWidgetWrapperCP'
import { RankingConsultantWidgetUtils } from 'main/modules/dashboard/components/widgets-row-ranking-consultant/inner/RankingConsultantWidgetUtils'
import { WidgetsRowCP } from 'main/modules/dashboard/components/widgets-row/WidgetsRowCP'
import { useRequest } from 'main/common/request-manager/use-request/UseRequest'
import { IGenericListResponseDTO } from 'main/common/dtos/responses/IGenericListResponseDTO'
import { DashboardRequests } from 'main/modules/dashboard/services/DashboardRequests'
import { ITableIndicatorsRequestWithOrderingDTO } from 'main/modules/dashboard/services/dtos/request/ITableIndicatorsRequestWithOrderingDTO'
import { SalesRankingIndicatorsOrderingEnum } from 'main/modules/dashboard/services/enums/SalesRankingIndicatorsOrderingEnum'
import { RequestUtils } from 'main/common/request-manager/RequestUtils'
import { ISalesRankingIndicatorsListItemResponseDTO } from 'main/modules/dashboard/services/dtos/response/ISalesRankingIndicatorsListItemResponseDTO'
import { IDateRangeFilter } from 'main/common/components/date-range-picker/inner/IDateRangeFilter'
import { DtoUtils } from 'main/common/dtos/utils/DtoUtils'
import { OrderingEnum } from 'main/common/enums/OrderingEnum'

interface ICPProps {
    franchiseCodes?: number[]
    dateFilters?: IDateRangeFilter
}

/**
 * Componente de tabela Ranking das consultoras avaliadoras
 */
export function WidgetsRowRankingConsultantCP(props: ICPProps): JSX.Element {

    const [sortCriteria, setSortCriteria] = useState<SalesRankingIndicatorsOrderingEnum>(SalesRankingIndicatorsOrderingEnum.SALE_VALUE)
    const [sortOrder, setSortOrder] = useState<OrderingEnum>(OrderingEnum.DESC)

    const getRankingByFranchiseRequest = useRequest<IGenericListResponseDTO<ISalesRankingIndicatorsListItemResponseDTO>>()
    useEffect(onGetRankingByFranchiseRequestChange, [getRankingByFranchiseRequest.isAwaiting])

    useEffect(init, [props.franchiseCodes, props.dateFilters, sortOrder, sortCriteria])

    /**
     * Busca dados na api.
     */
    function init(): void {

        const filters: ITableIndicatorsRequestWithOrderingDTO<SalesRankingIndicatorsOrderingEnum> = {
            franchiseCodes: props.franchiseCodes,
            dateRange: DtoUtils.convertToDateRangeDto(props.dateFilters),
            orderingCriteria: sortCriteria,
            orderingAscending: sortOrder === OrderingEnum.ASC,
        }

        getRankingByFranchiseRequest.runRequest(DashboardRequests.getConsultantRanking(filters))
    }

    /**
     * Retorno da requisicao.
     */
    function onGetRankingByFranchiseRequestChange(): void {
        if (!RequestUtils.isValidRequestReturn(getRankingByFranchiseRequest, 'Não foi possível obter ranking de avaliadoras'))
            return
    }

    return (
        <WidgetsRowCP>
            <CardDashboardWidgetWrapperCP
                title={'Ranking de Avaliadora'}
                flex={'1'}
            >
                <TableCPOLD2
                    columns={RankingConsultantWidgetUtils.getTableColumns()}
                    data={getRankingByFranchiseRequest.responseData?.list}
                    loading={getRankingByFranchiseRequest.isAwaiting}
                    sortDirections={[sortOrder]}
                    onSortingChange={(sortingParams) => {
                        setSortOrder(sortingParams.columnKey === sortCriteria ? (sortOrder === OrderingEnum.ASC ? OrderingEnum.DESC : OrderingEnum.ASC) : OrderingEnum.DESC)
                        setSortCriteria(sortingParams.columnKey as SalesRankingIndicatorsOrderingEnum)
                    }}
                />
            </CardDashboardWidgetWrapperCP>
        </WidgetsRowCP>
    )
}
